import { IngestionScheduleItem } from 'Modules/Studio/components/IngestionOverrideForm/IngestionOverrideForm';
import { getScheduleSummary } from '../../utilities/getScheduleSummary';
import { FC, useMemo } from 'react';

interface IngestionScheduleSummaryProp {
  ingestionSchedule: IngestionScheduleItem;
}
export const IngestionScheduleSummary: FC<IngestionScheduleSummaryProp> = ({
  ingestionSchedule,
}) => {
  const scheduleSummary = useMemo(() => getScheduleSummary(ingestionSchedule), [ingestionSchedule]);
  return (
    <div className="tw:flex tw:justify-center tw:items-center tw:bg-primary-300">
      <div className="tw:flex tw:flex-1 tw:items-center tw:text-secondary-400 tw:py-2.5 tw:px-6 tw:text-base">
        {scheduleSummary}
      </div>
    </div>
  );
};
